// Shared by the loan map page, its pins and its legend.

// Row layout from GET /map/loans (MAP_COLUMNS in hfcapi src/web/map).
export const COL = {
  loanId: 0,
  loanNumber: 1,
  custName: 2,
  branchIFSC: 3,
  lat: 4,
  lng: 5,
  activity: 6,
  idleDays: 7,
  progress: 8,
  review: 9, // activities awaiting review (Submitted)
  request: 10, // open disbursement requests
  offsite: 11, // photos taken outside the allowed radius (last 90 days)
};

// Pin fill = how recently the loan had photos uploaded.
export const ACTIVITY = [
  {
    key: 'active', label: 'Active', hint: 'Photos uploaded in the last 30 days', color: '#12B76A',
  },
  {
    key: 'slowing', label: 'Slowing', hint: 'Last upload 30–90 days ago', color: '#FDB022',
  },
  {
    key: 'dormant', label: 'Dormant', hint: 'Last upload 90 days – 1 year ago', color: '#667085',
  },
  {
    key: 'inactive', label: 'Inactive', hint: 'No upload for over a year', color: '#D0D5DD',
  },
  {
    key: 'notStarted', label: 'Not started', hint: 'No photos uploaded yet', color: '#FFFFFF', stroke: '#98A2B3',
  },
];
export const ACTIVITY_BY_KEY = ACTIVITY.reduce((m, a) => ({ ...m, [a.key]: a }), {});

// Pin ring = something to act on (first match wins).
export const FLAGS = [
  {
    key: 'offsite', label: 'Off-site photos', hint: 'Photos taken outside the allowed radius (last 90 days)', color: '#D92D20', col: COL.offsite,
  },
  {
    key: 'review', label: 'Awaiting review', hint: 'Activities submitted, not yet verified', color: '#2F6BEA', col: COL.review,
  },
  {
    key: 'request', label: 'Open request', hint: 'Open disbursement request', color: '#7A5AF8', col: COL.request,
  },
];

export const flagOf = (row) => FLAGS.find((f) => row[f.col] > 0) || null;

export const idleText = (idleDays) => {
  if (idleDays === null || idleDays === undefined) return 'No uploads yet';
  if (idleDays <= 0) return 'Last upload today';
  if (idleDays === 1) return 'Last upload yesterday';
  if (idleDays < 60) return `Last upload ${idleDays} days ago`;
  if (idleDays < 730) return `Last upload ${Math.round(idleDays / 30)} months ago`;
  return `Last upload ${Math.round(idleDays / 365)} years ago`;
};

// Frame the map on India when most pins are there (bad coordinates stay on
// the map, as entered, but shouldn't zoom it out to the whole world).
export const INDIA = {
  north: 37.5, south: 6, west: 68, east: 97.5,
};
export const inIndia = (lat, lng) => lat >= INDIA.south && lat <= INDIA.north
  && lng >= INDIA.west && lng <= INDIA.east;
